var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGalleryIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87516 23.4163H16.1252C21.3335 23.4163 23.4168 21.333 23.4168 16.1247V9.87467C23.4168 4.66634 21.3335 2.58301 16.1252 2.58301H9.87516C4.66683 2.58301 2.5835 4.66634 2.5835 9.87467V16.1247C2.5835 21.333 4.66683 23.4163 9.87516 23.4163Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87484 10.9167C11.0254 10.9167 11.9582 9.98393 11.9582 8.83333C11.9582 7.68274 11.0254 6.75 9.87484 6.75C8.72424 6.75 7.7915 7.68274 7.7915 8.83333C7.7915 9.98393 8.72424 10.9167 9.87484 10.9167Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28125 20.2393L8.41667 16.7913C9.23958 16.2393 10.4271 16.3018 11.1667 16.9372L11.5104 17.2393C12.3229 17.9372 13.6354 17.9372 14.4479 17.2393L18.7812 13.5205C19.5937 12.8226 20.9063 12.8226 21.7188 13.5205L23.4167 14.9788",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryIcon);
export default __webpack_public_path__ + "static/media/galleryIcon.c178fb2100327b563774d57d529b58e7.svg";
export { ForwardRef as ReactComponent };